import { Component, Input } from '@angular/core';

import { ModalController, ToastController, AlertController } from 'ionic-angular';
import { AlertMessager } from '../../../../lib/alertMessager';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/mergeMap';
import { Organization } from '../../../../model/organization';
import { NominationService } from '../../../../services/nomination.service';
import { HorseNomination } from '../../../../model/horseNomination';
import { Nomination } from '../../../../model/nomination';
import { AccountHelper } from '../../../../lib/accountHelper';
import { StallionLogsPage } from './stallion-logs';
import { NewStallionPage } from './new-stallion';
import { NominationHorseSlot } from '../../../../model/nominationHorseSlot';

@Component({
    selector: 'staff-stallions',
    templateUrl: 'stallions.html'
})
export class StallionsSection {
    _organization: Organization;
    _viewMode: string = 'overview';

    searchChangeObservable;
    searchQuery: string;
    searchResults: any = [];

    stallionSearchChangeObservable;
    stallionResults: NominationHorseSlot[] = [];
    stallions: NominationHorseSlot[] = [];
    rider: string;
    ownerName: string;
    horseName: string;
    sireName: string;
    breederName: string;

    confirmation: string;
    payConfirmation: string;
    scheduleFilter: string = 'Any';

    popoverActive: boolean;
    loadingData: boolean;

    exceededResults: boolean;

    @Input()
    set organization(organization: Organization) {
        if (organization != null) {
            this._organization = organization;


        }
    }
    get organization(): Organization {
        return this._organization;
    }

    @Input()
    set viewMode(viewMode: string) {
        if (viewMode != null) {
            this._viewMode = viewMode;
        }
    }
    get viewMode(): string {
        return this._viewMode;
    }

    constructor(private modalCtrl: ModalController, private alertController: AlertController, private alert: AlertMessager,
        private toast: ToastController, private nominationService: NominationService, ) { 
    }

    getSearchMessage() {
        if (this.loadingData)
            return "";

        if (this.searchQuery == undefined || this.searchQuery.trim().length == 0)
            return "";
        else if (this.searchResults == undefined || this.searchResults.length < 1) {
            return "There are no stallions by that name.";
        }

        return "";
    }

    onHorseSearchChange(searchValue: string) {
        this.onStallionSearchChange('horse' + searchValue);
    }

    onSireSearchChange(searchValue: string) {
        this.onStallionSearchChange('sire' + searchValue);
    }

    onOwnerSearchChange(searchValue: string) {
        this.onStallionSearchChange('owner' + searchValue);
    }

    onBreederSearchChange(searchValue: string) {
        this.onStallionSearchChange('breeder' + searchValue);
    }

    onConfirmationSearchChange(searchValue: string) {
        this.onStallionSearchChange('confirmation' + searchValue);
    }

    onPayConfirmationSearchChange(searchValue: string) {
        this.onStallionSearchChange('payConfirmation' + searchValue);
    }

    onStallionSearchChange(searchValue: string) {
        if (!this.stallionSearchChangeObservable) {
            Observable.create(observer => {
                this.stallionSearchChangeObservable = observer;
            }).debounceTime(300) 
              .distinctUntilChanged()
              .subscribe((text) => { this.filterNominations() });
        }

		this.stallionSearchChangeObservable.next(searchValue);
    }

    filterNominations() {
        this.stallionResults = this.organization.nominations.flatMap(x => x.horseNominationSlots);

        if (this.horseName) {
            this.stallionResults = this.stallionResults.filter(x => 
                x.horse.name.toLowerCase().indexOf(this.horseName) > -1);
        }

        if (this.ownerName) {
            this.stallionResults = this.stallionResults.filter(x => 
                x.horse.owner.name && x.horse.owner.name.toLowerCase().indexOf(this.ownerName) > -1);
        }

        if (this.breederName) {
            this.stallionResults = this.stallionResults.filter(x => 
                x.horse.breeder.name && x.horse.breeder.name.toLowerCase().indexOf(this.breederName) > -1);
        }

        this.stallionResults = this.stallionResults.sort((n1, n2) => {
            if (n1.horse.name < n2.horse.name)
                return -1;
            else if (n1.horse.name > n2.horse.name)
                return 1;

            if (n1.id < n2.id)
                return -1;
            else if (n1.id > n2.id)
                return 1;
        });
    }

    async viewStallionLogs(nomination: any) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;
        
        let logs = await this.nominationService.getNominationHorseSlotLogs(nomination.id);

        let entryModal = this.modalCtrl.create(StallionLogsPage, { logs: logs }, { cssClass: 'page-stallion-logs', enableBackdropDismiss: false });

        entryModal.present();
        entryModal.onDidDismiss((data) =>{
            this.popoverActive = false;
        });
    }

    addNewStallion() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let entryModal = this.modalCtrl.create(NewStallionPage, { organization: this.organization, staff: true }, { cssClass: 'page-new-stallion', enableBackdropDismiss: false });

        entryModal.present();
        entryModal.onDidDismiss((data) =>{
            this.popoverActive = false;

            if (!data && !data.stallions && data.stallions > 0) {
                data.stallions.foreach(stallionEntry => {
                    this.stallions.push(stallionEntry);
                });
            }
        });
    }

    editStallion(stallionSlot: any) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let entryModal = this.modalCtrl.create(NewStallionPage, { organization: this.organization, staff: true, stallionSlot: stallionSlot }, { cssClass: 'page-new-stallion', enableBackdropDismiss: false });

        entryModal.present();
        entryModal.onDidDismiss((data) =>{
            this.popoverActive = false;

            if (!data && !data.nominations && data.nominations > 0) {
                data.nominations.foreach(nominationEntry => {
                    let nomination = this.organization.nominations.filter(x => x.id == nominationEntry.nominationId)[0];

                    if (nomination != null)
                        nomination.nominations.filter(x => x.id == nominationEntry.id)[0] = nominationEntry;
                });
            }
        });
    }

    removeHorseSlot(nomination: Nomination, horseSlotEntry: NominationHorseSlot) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let alert = this.alertController.create({
            title: 'Confirm Horse Slot Removal',
            message: 'Do you want to remove this Horse Slot?',
            buttons: [
            {
                text: 'Yes',
                handler: () => {
                    this.nominationService.deleteNominationHorseSlot(horseSlotEntry)
                    .then(data => {
                        if (data == null || data == undefined) {
                            this.organization.nominations.filter(x => x.id == nomination.id)[0].horseNominationSlots = this.organization.nominations.filter(x => x.id == nomination.id)[0].horseNominationSlots.filter(x => x.id != horseSlotEntry.id)

                            this.toast.create({
                                message: 'Horse Slot was removed successfully.',
                                duration: 1500,
                                position: 'middle'
                            }).present();

                        } else if((data as any).message != null && (data as any).message != undefined) {
                            this.alert.showError("Horse Slot Removal Failed", (data as any).message);
                        }
                    }, error => { 
                            this.alert.showError("Horse Slot Removal Error", error); 
                    });
                }
            },
            {
                text: 'No',
                role: 'cancel',
                handler: () => { }
            }]
        });

        alert.present();

        alert.onDidDismiss(() => {
            this.popoverActive = false;
        })
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/organization/stallions/stallions.ts